var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Timer" }, [
    _c(
      "div",
      {
        staticClass: "containerTimer",
        staticStyle: { "--duration-static": "2.5", "--size-static": "250" }
      },
      [
        _c("div", { staticClass: "circle_mask" }),
        _c("div", { staticClass: "timer_container" }, [
          _c("div", { ref: "timer", staticClass: "timer" }, [
            _c("div", { staticClass: "mask" })
          ])
        ]),
        _c(
          "div",
          { ref: "circle", staticClass: "circle" },
          [_vm._t("default")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }